<template>
  <section class="advantages-section container">
    <h2 class="section-title">Kenapa Paradisa Studenté adalah Pilihan Investasi Terbaik?</h2>
    <div class="advantages-grid">
      
      <div class="advantage-card">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/></svg>
        </div>
        <h3>Potensi Yield Tinggi</h3>
        <p>Dapatkan potensi yield sewa hingga 8%, jauh di atas rata-rata sewa rumah konvensional (4%).</p>
      </div>

      <div class="advantage-card">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z"/><path d="m13 2 5 5h-5V2Z"/><path d="m10 12-2 2 2 2"/><path d="m14 12 2 2-2 2"/></svg>
        </div>
        <h3>Legalitas SHM Terjamin</h3>
        <p>Investasi aman dengan Sertifikat Hak Milik (SHM), bukan sebatas HGB Strata Title seperti apartemen.</p>
      </div>

      <div class="advantage-card">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 9V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2"/><path d="M20 15v-3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M4 15v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/><path d="M4 9h16"/></svg>
        </div>
        <h3>Unit Fully Furnished</h3>
        <p>Setiap unit sudah dilengkapi furnitur, AC, smart door lock, hingga water purifier, Anda siap langsung mendapatkan penyewa.</p>
      </div>

      <div class="advantage-card">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/><path d="M12 20h4"/><path d="M12 4H8"/><path d="M20 12v8h-4v-8"/><path d="M4 12v8h4v-8"/></svg>
        </div>
        <h3>Dikelola Profesional</h3>
        <p>Pengelolaan rukost Anda didukung oleh Estate Management berpengalaman selama 5 tahun untuk memastikan properti selalu terawat dan terisi.</p>
      </div>

      <div class="advantage-card">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
        </div>
        <h3>Lokasi Emas Dekat IPB</h3>
        <p>Berada di kawasan edukasi dengan target pasar pasti lebih dari 10.000 mahasiswa baru IPB setiap tahunnya.</p>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'KeyAdvantages'
}
</script>

<style scoped>
.advantages-section {
  text-align: center;
  padding: 80px 20px;
}

.section-title {
  font-size: 2.2rem;
  margin-bottom: 50px;
  color: var(--dark-grey);
}

.advantages-grid {
  /* MENGGUNAKAN GRID UNTUK 5 KOLOM */
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* KUNCI UTAMA: Membuat 5 kolom sama lebar */
  gap: 20px; /* Sedikit kurangi jarak agar muat */
  max-width: 1200px; /* Batasi lebar maksimum container */
  margin: 0 auto; /* Pusatkan container */
}

.advantage-card {
  background-color: #ffffff;
  padding: 25px; /* Kurangi padding agar konten tidak terlalu rapat */
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  display: flex;
  flex-direction: column;
  text-align: center;
}

.advantage-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  border-color: transparent;
}

.icon-wrapper {
  color: var(--primary-color);
  margin-bottom: 15px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantage-card h3 {
  font-size: 1.15rem; /* Sedikit kurangi ukuran font judul */
  color: var(--primary-color);
  margin-top: 0;
  margin-bottom: 15px;
  min-height: 2.3em; 
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantage-card p {
  font-size: 0.9rem; /* Sedikit kurangi ukuran font deskripsi */
  line-height: 1.5;
  color: #555;
  margin: 0;
  flex-grow: 1; 
}

/* Aturan untuk Tablet (di bawah 1200px) */
@media (max-width: 1200px) {
  .advantages-grid {
    /* Menjadi 3 kolom */
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Aturan untuk Mobile (di bawah 768px) */
@media (max-width: 768px) {
  .section-title {
    font-size: 1.8rem;
  }
  .advantages-grid {
    /* Menjadi 1 kolom */
    grid-template-columns: 1fr;
  }
  /* Kembalikan ukuran font di mobile agar tetap terbaca */
  .advantage-card h3 {
    font-size: 1.25rem;
    min-height: auto;
  }
   .advantage-card p {
    font-size: 0.95rem;
  }
}
</style>